import { render, staticRenderFns } from "./NewPrayer.vue?vue&type=template&id=5f854e02&scoped=true&"
import script from "./NewPrayer.vue?vue&type=script&lang=js&"
export * from "./NewPrayer.vue?vue&type=script&lang=js&"
import style0 from "./NewPrayer.vue?vue&type=style&index=0&id=5f854e02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f854e02",
  null
  
)

export default component.exports